import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

type FooterWrapperProps = {
  bgColor?: string;
  lineColor?: string;
  isDefaultApp?: boolean;
  component?: string;
};
export const StFooterWrapper = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'bgColor',
})<FooterWrapperProps>(({ theme, bgColor, lineColor, isDefaultApp }) => ({
  backgroundColor: bgColor || theme.palette.footerBackgroundColor.main,
  borderTop: isDefaultApp ? `1px solid ${lineColor}` : 'none',
}));

export const StFooterContainer = styled(Grid)<FooterWrapperProps>(({ theme, isDefaultApp }) => {
  const defaultPadding = isDefaultApp ? '2rem 3rem 0' : '2rem 2rem';

  return {
    boxSizing: 'border-box',
    minHeight: '7rem',
    bottom: 0,
    padding: defaultPadding,

    [theme.breakpoints.up('xl')]: {
      width: '1300px',
      margin: '0 auto !important',
    },
    [theme.breakpoints.down('sm')]: {
      padding: isDefaultApp ? '2rem 1rem 0' : '2rem 2rem',
    },
    [theme.breakpoints.between(430, 800)]: {
      padding: isDefaultApp ? '2rem 1rem' : '2rem 2rem',
    },
  };
});

export const StPrimaryLinkContainer = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    height: 'fit-content',
  },
}));
export const StFooterIconContainer = styled(Grid)(({ theme }) => ({
  order: 0,

  [theme.breakpoints.down('md')]: {
    order: 3,
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
  },

  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    height: 'fit-content',
    marginBottom: '22px',
    padding: '0',
  },

  [theme.breakpoints.between(600, 700)]: {
    paddingLeft: '6rem',
    paddingRight: '6rem',
  },
  [theme.breakpoints.between(700, 'lg')]: {
    paddingLeft: '9rem',
    paddingRight: '9rem',
    order: 3,
    justifyContent: 'center',
  },
}));

export const StSocialMediaContainer = styled(Grid)(({ theme }) => ({
  marginTop: '1.5rem',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: 0,
  },
}));

export const StSocialMediaDefaultContainer = styled(Grid)(({ theme }) => ({
  marginTop: '1rem',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingTop: '1rem',
    paddingBottom: '1rem',
  },
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingTop: '1rem',
    paddingBottom: '1rem',
  },
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: 'fit-content',
    margin: '0',
    padding: 0,
  },
}));

export const StSecondaryLinkContainer = styled(Grid)(({ theme }) => ({
  marginTop: '1.5rem',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  [theme.breakpoints.between(600, 700)]: {
    paddingLeft: '6rem',
    paddingRight: '6rem',
  },
  [theme.breakpoints.between(700, 'lg')]: {
    paddingLeft: '9rem',
    paddingRight: '9rem',
  },
}));

export const StSecondaryLinkDefaultContainer = styled(Grid)(({ theme }) => ({
  marginTop: '1rem',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    height: 'fit-content',
    margin: '15px 0px',
  },
  [theme.breakpoints.between(600, 700)]: {
    paddingLeft: '4rem',
    paddingRight: '4rem',
  },
  [theme.breakpoints.between(700, 'lg')]: {
    paddingLeft: '7rem',
    paddingRight: '7rem',
  },
}));

export const StCopyRightText = styled(Grid)(({ theme }) => ({
  marginTop: '1.5rem',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'row',
    justifyContent: 'center',
    textAlign: 'center',
  },
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  [theme.breakpoints.between('sm', 'lg')]: {
    marginTop: '1rem',
  },
  '& div p': {
    display: 'inline',
    marginBottom: 0,
  },
})) as typeof Grid;

export const StDefaultCopyRightText = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'row',
    justifyContent: 'center',
    textAlign: 'center',
    marginTop: '2rem',
  },
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'center',
    textAlign: 'center',
    marginTop: '15px',
  },
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    textAlign: 'center',
    marginTop: '15px',
  },
  [theme.breakpoints.between('sm', 'lg')]: {
    marginTop: '1rem',
  },
  '& div p': {
    display: 'inline',
    marginBottom: 0,
  },
})) as typeof Grid;

export const StDisclaimerText = styled(Grid)(({ theme }) => ({
  marginTop: '1.5rem',
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'row',
    justifyContent: 'center',
    textAlign: 'center',
  },
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
}));
